import * as React from "react";
import { IButtonEvents } from "../_common/buttonEvents";
import { Wrapper } from "./components/Wrapper";

export interface IBaseSpinButton extends IButtonEvents {
  disabled?: boolean;
}

export const BaseSpinButton = (props: IBaseSpinButton) => (
  <Wrapper {...props} />
);
